import React, { useEffect, useState } from "react";
import { apiFetch } from "../../api/httpClient";
import "./PlenosVideo.css";

const PlenosVideo = () => {
  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    apiFetch("/actas-video")
      .then(data => {
        setVideos(data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Error al cargar los vídeos:", err);
        setIsLoading(false);
      });
  }, []);

  return (
    <section className="plenos-video">
      <div className="container">
        <h1>Plenos en Vídeo</h1>
        <p>Selecciona la sesión y te llevamos a su página pública.</p>

        {isLoading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p className="loading-text">Cargando vídeos…</p>
          </div>
        ) : (
          <ul className="videos-list">
            {videos.map(video => (
              <li key={video.id}>
                <a
                  className="video-card"
                  href={video.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="thumb"
                    src={
                      video.miniatura ||
                      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
                    }
                    alt=""
                    loading="lazy"
                  />
                  <div className="info">
                    <h3>{video.titulo}</h3>
                    <p>{new Date(video.fecha).toLocaleDateString()}</p>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default PlenosVideo;
